<template>
  <AnnouncementCard
    v-if="shouldShowBanner"
    localStorageKey="cloudstrike-pricing-card"
    @close="handleCloseButtonClick"
  >
    <div :class="$style.mainContent">
      <div :class="$style.leftSide">
        <HeadingMedium>
          JumpCloud Pricing for CrowdStrike Customers
        </HeadingMedium>
        <ParagraphBody :class="$style.paragraph">
          JumpCloud has Device Management specific pricing options for CrowdStrike customers
          which includes Patch Management and Full Disk Encryption.
        </ParagraphBody>
        <ButtonSecondary
          :class="$style.ctaButton"
          data-test-id="CrowdstrikePricingCard__ctaButton"
          text="Talk To Sales"
          @click="handleCtaButtonClick"
        />
      </div>
      <div>
        <img
          alt="Crowdstrike + JumpCloud"
          :class="[$style.image, $style.reducedResolution]"
          src="img/growth/crowdstrike_jc_graphic.png"
        >
      </div>
    </div>
  </AnnouncementCard>
</template>

<script>
import {
  ButtonSecondary,
  HeadingMedium,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import {
  eventLocations,
  eventProperties,
} from 'client/GrowthEngineering/utilities/GrowthConstants';
import { mapActions, mapGetters } from 'vuex';
import AnnouncementCard from 'client/components/AnnouncementCard/AnnouncementCard.vue';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import Util from 'client/util/Util';

const {
  description,
  location,
  section,
  text,
} = eventProperties;
const { pricingPage } = eventLocations;

const partnersModule = 'PartnersModule';

export default {
  name: 'CrowdstrikePricingCard',

  components: {
    AnnouncementCard,
    ButtonSecondary,
    HeadingMedium,
    ParagraphBody,
  },

  EventHelper,
  Util,

  computed: {
    ...mapGetters(partnersModule, {
      isCrowdStrikeAccount: 'hasActiveCrowdStrikeLink',
      isPendingCrowdStrikeAccount: 'hasPendingCrowdStrikeTrial',
    }),

    shouldShowBanner() {
      return this.isCrowdStrikeAccount || this.isPendingCrowdStrikeAccount;
    },
  },

  mounted() {
    this.fetchPartners();
  },

  methods: {
    ...mapActions(partnersModule, ['fetchPartners']),

    handleCloseButtonClick() {
      this.$options.EventHelper.triggerButtonClicked({
        [description]: 'User clicked CrowdStrike banner close button',
        [location]: pricingPage,
        [section]: 'CrowdStrike Pricing Banner',
      });
    },

    handleCtaButtonClick() {
      this.$options.Util.openUrl('https://hello.jumpcloud.com/calendar/team/t/55');
      this.$options.EventHelper.triggerButtonClicked({
        [description]: 'User clicked CrowdStrike banner "Talk to Sales" button',
        [location]: pricingPage,
        [section]: 'CrowdStrike Pricing Banner',
        [text]: 'talk to sales',
      });
    },
  },
};
</script>

<style module scoped>
@value (max-width-small) from '~css/breakpoints.css';

.cardContainer {
  display: flex;
}

.ctaButton {
  width: fit-content;
}

.closeButton {
  flex-shrink: 0;
}

.image {
  height: auto;
  width: 20rem;
}

.leftSide {
  display: flex;
  flex-direction: column;
}

@media (max-width: max-width-small) {
  .reducedResolution {
    display: none;
  }
}

.mainContent {
  display: flex;
  justify-content: space-between;
  text-align: left;
}

.paragraph {
  flex-grow: 1;
  flex-wrap: wrap;
  width: 90%;
}
</style>
